var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardSettingAlertsettingManagesymbolfilesPopupFailIcon = function SvgNewcsDashboardSettingAlertsettingManagesymbolfilesPopupFailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 48
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_setting_alertsetting_managesymbolfiles_popup_fail_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M480 317h64v48h-64z",
    "data-name": "\\u77E9\\u5F62 586"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_setting_alertsetting_managesymbolfiles_popup_fail_icon_svg__a)",
    transform: "translate(-480 -317)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M503.346 344.707a18.45 18.45 0 0 0 36.9 0 18.45 18.45 0 1 0-36.9 0",
    "data-name": "\\u8DEF\\u5F84 517",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393157",
    d: "M530.8 361.478h-6.51a2.013 2.013 0 1 1 0-4.025h6.51a9.157 9.157 0 1 0 0-18.314h-.336a2.013 2.013 0 0 1-2.015-1.979 16.44 16.44 0 0 0-32.873-.034 2.013 2.013 0 0 1-2.01 1.974h-.336a9.174 9.174 0 1 0 0 18.348h5.943a2.013 2.013 0 1 1 0 4.025h-5.943a13.194 13.194 0 0 1-1.578-26.3 20.479 20.479 0 0 1 40.7 0 13.194 13.194 0 0 1-1.545 26.3Z",
    "data-name": "\\u8DEF\\u5F84 518"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393157",
    d: "M520.922 364.497a1.824 1.824 0 0 1-2.516 0l-15.898-15.899a1.78 1.78 0 0 1 2.516-2.516l15.9 15.9a1.706 1.706 0 0 1 0 2.516Zm0-15.9-15.9 15.9a1.824 1.824 0 0 1-2.516 0 2.33 2.33 0 0 1-.335-2.518l15.9-15.9a2.26 2.26 0 0 1 2.851 0 1.76 1.76 0 0 1 0 2.516Z",
    "data-name": "\\u8DEF\\u5F84 519"
  }))));
};
export default SvgNewcsDashboardSettingAlertsettingManagesymbolfilesPopupFailIcon;